/* global globalThis */
import { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExamHeader from "../../components/exam-header/exam-header";
import ExamFooter from "../../components/exam-footer/exam-footer";
import ExamQuestionContainer from "../../components/exam-question-container/exam-question-container";
import ExamQuestionNumberList from "../../components/exam-question-number-list/exam-question-number-list";
import ExamReviewDrawer from "../../components/exam-review-drawer/exam-review-drawer";
import { Box, Backdrop, CircularProgress, IconButton, Snackbar } from "@material-ui/core";
import { useHistory, useParams, useLocation } from "react-router-dom";
import mixpanel from 'mixpanel-browser';
import { api } from "../../services/apiService";
import { applyClientConfig } from "../../constants/app-constant";
import { Launch } from "@material-ui/icons";
import {
  getQuiz,
  submitQuiz,
  resetSubmitQuiz,
  getQuestionMetadata,
  getQuestionHistory,
  reviewQuestion,
  resetQuiz,
  setUserActivity,
  getImage,
  resetQuestionMetadata,
  endTutorFeedbackBlock,
  resetQuesFeedback,
  getDemoQuestionMetadata,
  getDemoQuestionIDs,
  resetDemoQuestionMetadata,
  resetDemoQuestionIDs,
  getQuizHistory
} from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { persistAttribution } from "../../utils/attribution";
import {
  hasUsableDemoQuestionMetadata,
  resolveQuestionMetadataError,
} from "./examMetadata";

let examHistoryData = {};
let strikedHistoryData = {};
const reviewTimer = {};
const testingTime = {};
let interval;
let guideWindow = null;

//test comment

const normalizeQLinkPlatform = (value) => {
  const normalized = value?.trim().toLowerCase();
  if (normalized && /^[a-z0-9_-]{1,50}$/.test(normalized)) {
    return normalized;
  }

  return 'unknown';
};

const getQuestionIds = (questions = []) => (
  [...questions].map(item => item?.id || item?.questionId).filter(Boolean)
);

const normalizeQuestions = (questions = []) => (
  [...questions].map(q => ({
    ...q,
    questionId: q?.questionId || q?.id
  }))
);

const mergeQuestionsWithMetadata = (questions = [], metadata = []) => {
  if (!questions.length) {
    return normalizeQuestions(metadata);
  }

  const metadataById = new Map(
    normalizeQuestions(metadata).map(item => [item.questionId, item])
  );

  return normalizeQuestions(questions).map(question => {
    const metadataItem = metadataById.get(question.questionId);
    return metadataItem ? { ...question, ...metadataItem } : question;
  });
};

export default function ExamPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [showEndBlock, setShowEndBlock] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [currentQuestionNum, setCurrentQuestionNum] = useState(1);
  const [questionsData, setQuestionsData] = useState([]);
  const [questionMetadataArr, setQuestionMetadataArr] = useState([]);
  const [quizHistoryData, setQuizHistoryData] = useState([]);
  const [zoomClass, setZoomClass] = useState("smallFont");
  const [imageData, setImageData] = useState("");
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [quesMetadata, setQuesMetadata] = useState({});
  const [isTutorRole, setIsTutorRole] = useState(false);
  const [open, setOpen] = useState(false);
  const [errMsg, setErrMsg] = useState(false);
  const [isUserAcquisition, setIsUserAcquisition] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [qlinkPlatform, setQlinkPlatform] = useState(null);

  const location = useLocation();
  const currentRoute = location.pathname;

  const { examId, currentQuestion, review, tutor, guide, qId } = useParams();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const authenticatedMetadataRequestRef = useRef("");
  const questionParam = {
    question_list: []
  };

  const examDetails = useSelector((state) => {
    return state.quizDetails?.quizDetails;
  });

  const examDetailsLoading = useSelector((state) => {
    return state.quizDetails?.loading;
  });

  const questionHistory = useSelector((state) => {
    return state.questionHistory?.questionHistory;
  });

  const submitQuizRes = useSelector((state) => {
    return state.submitQuiz?.submitQuiz;
  });

  const questionMetadataState = useSelector((state) => {
    return state.questionMetadata;
  });

  const questionMetadata = questionMetadataState?.questionMetadata;
  const questionMetadataLoading = questionMetadataState?.loading === true;
  const questionMetadataLoaded = Array.isArray(questionMetadata) || !!questionMetadataState?.questionMetadataErrMsg;

  const reviewQuestionData = useSelector((state) => {
    return state.reviewQuestion;
  });

  const imageDataRes = useSelector((state) => {
    return state.getImage;
  });

  const setQuesTutorFeedbackRes = useSelector((state) => {
    return state.setQuesTutorFeedback;
  });

  const demoQuestionMetadata = useSelector((state) => {
    return state.getDemoQuestionMetadata;
  });

  const qlinkQsIds = useSelector((state) => {
    return state.getDemoQuestionIds;
  });

  const userDetailsFromTokenRes = useSelector((state) => {
    return state.userDetailsFromToken?.userDetails;
  });

  const handleClose = () => {
    setOpen(false);
    setErrMsg(false);
  };

  const startTimer = () => {
    const questionData = questionsData[currentQuestionNum - 1];

    if (review) {
      const questionHistoryData = questionHistory.filter(
        (item) => item.questionId === questionData?.questionId
      );

      interval = setInterval(() => {
        reviewTimer[questionData?.questionId] =
          reviewTimer[questionData?.questionId] + 1 ||
          questionHistoryData[0]?.reviewTimeSpent ||
          1;
      }, 1000);
    } else {
      interval = setInterval(() => {
        testingTime[questionData?.questionId] = testingTime[questionData?.questionId] + 1 || 1;
      }, 1000);
    }
  };

  const updateReviewApi = () => {
    const questionData = questionsData[currentQuestionNum - 1];
    const questionHistoryData = questionHistory.filter(
      (item) => item.questionId === questionData?.questionId
    );

    const param = {
      questionId: questionHistoryData[0]?.id,
      reviewTime: {
        reviewTimeSpent: reviewTimer[questionData?.questionId],
      },
    };

    dispatch(reviewQuestion(param));
  };

  const endFeedBackBlock = () => {
    const blockId = window.localStorage.getItem('feedbackBlockId');

    if (blockId) {
      dispatch(endTutorFeedbackBlock(blockId));
      window.localStorage.removeItem('feedbackBlockId');
    }
  }

  const preventNav = (event) => {
    updateReviewApi();

    const e = event || window.event;
    e.preventDefault();

    if (e) {
      e.returnValue = "";
    }

    return "";
  };

  const setTutorRole = (isUserAcq) => {
    const role = window.localStorage.getItem('role');
    const isTutorRole = role === 'ROLE_TUTOR';
    setIsTutorRole(isTutorRole);

    if (role) {
      setIsUserLoggedIn(true);
    }

    if (role && !isTutorRole & !isUserAcq) {
      window.addEventListener("beforeunload", preventNav);
      // Re-entry guard is for ACTIVE exams only. Review mode is read-only:
      // a refresh, bookmark, back/forward, or shared link into /review is a
      // POP entry, and punting it to the quiz builder silently destroys the
      // student's review session (UX-sweep slice-2 P1 QREV-1 — the REVIEW
      // deep-link rendered create-quiz with dead counts and no explanation).
      if (history.action === "POP" && !review) {
        history.push("/create-quiz");
      }
    }
  }
  const onExamCompLoad = () => {
    let isUserAcq = false;

    // For User Acquisition flow
    if (currentRoute.includes("/question/view")) {
      isUserAcq = true;
      setIsUserAcquisition(isUserAcq);
      setCurrentQuestionNum(1);
      persistAttribution();

      // Extract platform from URL for QLink session tracking
      const urlParams = new URLSearchParams(window.location.search);
      setQlinkPlatform(normalizeQLinkPlatform(urlParams.get('platform')));

      if (qId) {
        dispatch(getDemoQuestionIDs(qId));
      }
    }

    setTutorRole(isUserAcq);
  }

  // Runtime client-config (in-quiz egress C0): pinned bundles cannot receive
  // a CRA build-time flag, so resolve serverGradingEnabled from the server at
  // quiz mount. Fail-open: any error/non-200/malformed payload is a no-op and
  // the flag keeps its built value (OFF today).
  useEffect(() => {
    api.getClientConfig().then(applyClientConfig).catch(() => {});
  }, []);

  useEffect(() => {
    onExamCompLoad();

    return () => {
      if (!isUserAcquisition) {
        dispatch(resetQuesFeedback());
        handleClose();
      }

      if (guideWindow) {
        guideWindow.close();
      }
      const role = window.localStorage.getItem('role');
      const isTutorRole = role === 'ROLE_TUTOR';
      if (!isTutorRole) {
        window.removeEventListener("beforeunload", preventNav);

        setTimeout(() => {
          dispatch(resetQuiz());
          setQuestionsData([]);
        }, 300);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (qlinkQsIds && qlinkQsIds?.demoQsIds) {
      const demoQsIds = getQuestionIds(qlinkQsIds?.demoQsIds);

      globalThis.localStorage.setItem("userAcqQuesId", qId);
      if (globalThis.localStorage.getItem("token")) {
        fetchAcquisitionQuestionMetadata(demoQsIds);
        return;
      }

      dispatch(getDemoQuestionMetadata({ question_list: demoQsIds }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qlinkQsIds]);

  useEffect(() => {
    if (!examId) {
      return;
    }

    dispatch(getQuiz(examId));

    if (review || tutor) {
      dispatch(getQuestionHistory(examId));
      dispatch(getQuizHistory(examId));
    }
  }, [dispatch, examId, review, tutor]);

  useEffect(() => {
    if (examDetails && examDetails.questions) {
      setQuestionsData(examDetails.questions);
      return;
    }
    setQuestionsData([]);
  }, [examDetails]);

  // Review mode is only legitimate for COMPLETED quizzes. Without this gate,
  // a mid-exam student could open /exam/<id>/1/review in a second tab and
  // read the answer key the review UI renders (adversarial gate on #517 —
  // the POP exemption alone lowered that bar to a URL edit). Enforced on the
  // loaded quiz details regardless of how the route was entered.
  useEffect(() => {
    if (review && examDetails && examDetails.quizStatus && examDetails.quizStatus !== "COMPLETE") {
      history.replace("/create-quiz");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [review, examDetails, history]);

  useEffect(() => {
    if (demoQuestionMetadata) {
      if (demoQuestionMetadata?.questionMetadata && !demoQuestionMetadata?.questionMetadata?.errMsg) {
        const ques = normalizeQuestions(demoQuestionMetadata?.questionMetadata);

        if (globalThis.localStorage.getItem("token")) {
          setQuestionsData(prevQuestions => prevQuestions.length ? prevQuestions : [...ques]);
          return;
        }

        setQuestionsData([...ques]);
        setQuestionMetadataArr([...ques]);
      } else if (demoQuestionMetadata?.errMsg) {
        setErrMsg(demoQuestionMetadata?.errMsg);
      }
    }
  }, [demoQuestionMetadata]);

  function fetchAcquisitionQuestionMetadata(questionIds = getQuestionIds(questionsData), options = {}) {
    const { force = false, allowDemoFallback = true } = options;
    const qsIds = [...questionIds].filter(Boolean);

    if (!qsIds.length) {
      return;
    }

    if (globalThis.localStorage.getItem("token")) {
      const requestKey = qsIds.join("|");
      if (force || authenticatedMetadataRequestRef.current !== requestKey) {
        authenticatedMetadataRequestRef.current = requestKey;
        dispatch(getQuestionMetadata({ question_list: qsIds }));
      }
      return;
    }

    if (allowDemoFallback && globalThis.localStorage.getItem("userAcquisitiontoken")) {
      dispatch(getDemoQuestionMetadata({ question_list: qsIds }));
    }
  }
  
  
  const fetchQuestionMetadata = () => {
    if (questionsData?.length && !isUserAcquisition) {
      questionsData.forEach((element) => {
        questionParam.question_list.push(element.questionId);
      });
      if (questionParam.question_list.length) {
          dispatch(getQuestionMetadata({ ...questionParam, ...(examId ? { quizId: examId } : {}) }));

        if (questionHistory?.length) {
          setQuizHistoryData(questionHistory);
        }
      }
    } else if (questionsData?.length && isUserAcquisition) {
      fetchAcquisitionQuestionMetadata(undefined, { force: true });
    }
  }

  useEffect(() => {
    if (questionsData?.length && !isUserAcquisition) {
      questionsData.forEach((element) => {
        questionParam.question_list.push(element.questionId);
      });

      if (questionParam.question_list.length) {
        if (!questionMetadata) {
          dispatch(getQuestionMetadata({ ...questionParam, ...(examId ? { quizId: examId } : {}) }));
        }

        if (questionHistory?.length) {
          setQuizHistoryData(questionHistory);
        }
      }
    } else if (questionsData?.length && isUserAcquisition) {
      const token = globalThis.localStorage.getItem("token");
      const userAcquisitiontoken = globalThis.localStorage.getItem("userAcquisitiontoken");
      const shouldFetchQLinkMetadata = token ||
        (userAcquisitiontoken && !hasUsableDemoQuestionMetadata(demoQuestionMetadata));

      if (shouldFetchQLinkMetadata) {
        fetchAcquisitionQuestionMetadata();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, questionHistory, questionsData, isUserAcquisition, userDetailsFromTokenRes]);

  useEffect(() => {
    if (currentQuestion) {
      const number = parseInt(currentQuestion);
      setCurrentQuestionNum(number);
    }

    if (questionsData && questionsData.length) {
      const questionData = questionsData[currentQuestionNum - 1];

      if (questionData?.imageList?.length && (!imageDataRes?.image || !imageDataRes?.image[questionData.imageList[0]])) {
        dispatch(getImage(questionData.imageList[0]));
      }

      if (!tutor && !review) {
        startTimer();

        return () => {
          clearInterval(interval);
        };
      } else if (review && questionHistory) {
        startTimer();

        return () => {
          examHistoryData = {};
          clearInterval(interval);
          updateReviewApi();
        };
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentQuestion, questionsData, questionHistory]);

  useEffect(() => {
    if (questionMetadata && questionMetadata.length) {
      if (isUserAcquisition) {
        const metadataQuestions = normalizeQuestions(questionMetadata);
        setQuestionMetadataArr(metadataQuestions);
        setQuestionsData(prevQuestions => mergeQuestionsWithMetadata(prevQuestions, metadataQuestions));
        return;
      }

      setQuestionMetadataArr(questionMetadata);
    }
  }, [questionMetadata, isUserAcquisition]);

  useEffect(() => {
    if (reviewQuestionData && reviewQuestionData.isLoading !== undefined) {
      setIsLoading(reviewQuestionData.isLoading);
    }
  }, [reviewQuestionData]);

  useEffect(() => {
    if (submitQuizRes && submitQuizRes.quizStatus === "COMPLETE") {
      // Null-safe: same analytics-before-navigation hazard as the
      // quiz-history Review button (this parse ran before history.push).
      let userinfos = {};
      try {
        userinfos = JSON.parse(localStorage.getItem('userdetails')) || {};
      } catch (e) {
        // tracking context is optional; submission flow is not
      }
      const userrole = window.localStorage.getItem("role");
      const isDiagnosticQuiz = submitQuizRes?.quizType === "ABSITE_DIAGNOSTIC"
        || examDetails?.quizType === "ABSITE_DIAGNOSTIC";
      history.push(isDiagnosticQuiz ? `/absite-diagnostic/${examId}/report` : `/result/${examId}`);
      examHistoryData = {};
      strikedHistoryData = {};
      dispatch(resetSubmitQuiz());
      dispatch(resetQuiz());
      setQuestionsData([]);

      if (review) {
        mixpanel.track('Review quiz completed', {
          examId
        });
      } else if (tutor) {
        mixpanel.track('Tutoring quiz completed', {
          examId
        });
      } else {
        mixpanel.track('Quiz completed', {
          $name: userinfos.name,
          "Value": 10.00, // Assign a monetary value to the event
          email: userinfos.email,
          role: userrole
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, examId, history, submitQuizRes]);

  useEffect(() => {
    const questionData = questionsData[currentQuestionNum - 1];
    if (imageDataRes && imageDataRes?.loading) {
      setIsImageLoading(true);
      return;
    }

    if (imageDataRes?.image && questionData?.imageList?.length && imageDataRes?.image[questionData.imageList[0]]) {
      setImageData(imageDataRes?.image[questionData.imageList[0]]);
    } else {
      setImageData('');
    }
    setIsImageLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageDataRes, currentQuestion, questionsData]);

  useEffect(() => {
    if (isTutorRole && questionsData) {
      const questionData = questionsData[currentQuestionNum - 1];
      if (questionMetadata && questionMetadata.length) {
        const currentQues = questionMetadata.filter(
          (item) => item.id === questionData?.questionId
        );
        setQuesMetadata(currentQues[0]);
        const channel = new BroadcastChannel('app-data');
        channel.postMessage(currentQues[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionMetadata, currentQuestionNum]);

  useEffect(() => {
    if (setQuesTutorFeedbackRes?.quesTutorFeedback && setQuesTutorFeedbackRes?.loading === false) {
      setOpen(true);
    }

    if (setQuesTutorFeedbackRes?.errorMsg && setQuesTutorFeedbackRes?.loading === false) {
      setErrMsg(setQuesTutorFeedbackRes?.errorMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setQuesTutorFeedbackRes]);

  useEffect(() => {
    if (userDetailsFromTokenRes?.status === 200 || userDetailsFromTokenRes?.id) {
      const userAcquisitionQuesId = window.localStorage.getItem("userAcqQuesId");
      if (userAcquisitionQuesId) {
        if (userDetailsFromTokenRes?.id) {
          window.localStorage.setItem("userId", userDetailsFromTokenRes?.id);
          window.localStorage.setItem("role", userDetailsFromTokenRes?.primaryRole);
        }

        setTimeout(() => {
          onExamCompLoad();
        }, 500);

      }
    } else if (userDetailsFromTokenRes && (userDetailsFromTokenRes?.status === 401 || !userDetailsFromTokenRes?.id)) {
      alert('User not registered');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetailsFromTokenRes]);

  const handleQuestionSelection = (questionIndex) => {
    const userAcqQuesId = window.localStorage.getItem("userAcqQuesId");
    setCurrentQuestionNum(questionIndex);

    if (tutor) {
      history.push(`/exam/${examId}/${questionIndex}/tutor/1`);
    } else if (!review && !userAcqQuesId) {
      history.push(`/exam/${examId}/${questionIndex}`);
    } else {
      addUserActivityOnReview();
      if (!userAcqQuesId) {
        dispatch(getQuestionHistory(examId));
        dispatch(getQuizHistory(examId));
        history.push(`/exam/${examId}/${questionIndex}/review`);
      }
    }
  };

  const handleTextZoom = (className) => {
    setZoomClass(className);
  };

  const handleProceedToNextQuestion = () => {
    const userAcqQuesId = window.localStorage.getItem("userAcqQuesId");
    const num = currentQuestionNum + 1;
    setCurrentQuestionNum(num);

    if (tutor) {
      history.push(`/exam/${examId}/${num}/tutor/1`);
    } else if (!review && !userAcqQuesId) {
      history.push(`/exam/${examId}/${num}`);
    } else {
      addUserActivityOnReview();
      if (!userAcqQuesId) {
        dispatch(getQuestionHistory(examId));
        dispatch(getQuizHistory(examId));
        history.push(`/exam/${examId}/${num}/review`);
      }
    }
  };

  const onExamHistoryChange = (data, type, extraData) => {
    examHistoryData = { ...data };

    if (type === "marked") {
      setQuestionsData([...extraData]);
    }
  };

  const onStrikeDataChange = (data) => {
    strikedHistoryData = { ...data };
  };

  const getMarkedVal = (quesId) => {
    if (questionMetadata && !questionMetadata?.errMsg) {
      const ques = questionMetadata?.filter(item => item.id === quesId);

      return questionMetadata && ques?.length ? ques[0].marked : false;
    }
    return false;

  };

  const onEndBlock = (timeLeft, type) => {
    setShowEndBlock(false);
    setImageData('');
    dispatch(resetQuestionMetadata());

    if (!review) {
      const timePerQues = 90;
      const timeSpent = timePerQues * questionsData.length - (timeLeft || 0);

      const questionHistories = questionsData.map((item) => {
        return {
          questionId: item.questionId,
          answerGiven: examHistoryData[item.questionId]?.answerGiven,
          marked: examHistoryData[item.questionId]?.marked !== undefined ? examHistoryData[item.questionId]?.marked : getMarkedVal(item.questionId),
          timeSpent: testingTime[item.questionId],
          answersAttempted: [],
          questionNo: item.questionNo
        };
      });

      const param = {
        questionHistories,
        quizHistory: {
          quizId: examId,
          userId: examDetails.userId,
          questionAttemptCount: questionsData.length,
          quizSubmitDate: moment().format('YYYY-MM-DDTHH:mm:ss.sss') + 'Z',
          quizDuration: examDetails?.timerOn ? timeSpent : 0
        },
      };

      dispatch(submitQuiz(param));
    } else {
      clearInterval(interval);

      if (type === "submitted" || type === "reviewEnd") {
        endFeedBackBlock();
        updateReviewApi();
        if (type === "reviewEnd") {
          history.push('/create-quiz');
        } else {
          const isDiagnosticQuiz = examDetails?.quizType === "ABSITE_DIAGNOSTIC";
          history.push(isDiagnosticQuiz ? `/absite-diagnostic/${examId}/report` : `/result/${examId}`);
        }
        setQuestionsData([]);
      } else if (type === "remain-in-block") {
        startTimer();
      }
    }
  };

  const addUserActivityOnReview = () => {
    const savedUserId = window.localStorage.getItem("userId");
    if (savedUserId) {
      dispatch(setUserActivity({
        userId: savedUserId,
        videoAccessCount: 1
      }));
    }

  };

  const onShowEndBlock = (show) => {
    setShowEndBlock(show);
  };

  const onFeedbackOpen = (show) => {
    setFeedbackOpen(show);
  };

  const goToHomePage = () => {
    if (review) {
      dispatch(resetQuestionMetadata());
      clearInterval(interval);
      endFeedBackBlock();
      updateReviewApi();
      history.push(`/create-quiz`);
    } else if (isUserAcquisition) {
      history.push(`/create-quiz`);
      dispatch(resetDemoQuestionMetadata());
      dispatch(resetDemoQuestionIDs());
      window.localStorage.removeItem("userAcqQuesId");
      window.localStorage.removeItem("userAcquisitiontoken");
    }
  };

  const onGuidePopOut = () => {
    if (!guideWindow) {
      let path = window.location.pathname;

      if (review) {
        path = path.replace('review', 'tutor/1');
      }

      guideWindow = window.open(path + '/guide/1', '_blank', 'width=800,height=700,left=700,popup');

      guideWindow.addEventListener('load', () => {
        guideWindow.addEventListener('beforeunload', (e) => {
          e.preventDefault();
          guideWindow = null;
          e.returnValue = true;
        });
      });
    } else {
      alert('Guide already open');
    }
  }

  // Add a new useEffect to handle browser navigation and ensure data is reloaded
  useEffect(() => {
    // Listen for popstate event (when user uses browser back/forward buttons)
    const handlePopState = () => {
      if (examId && (review || tutor)) {
        // Re-fetch question history when navigating with browser controls
        dispatch(getQuestionHistory(examId));
      }
    };

    window.addEventListener('popstate', handlePopState);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [dispatch, examId, review, tutor]);

  // Keep quizHistoryData in sync whenever questionHistory is updated
  useEffect(() => {
    if (questionHistory && questionHistory.length) {
      setQuizHistoryData(questionHistory);
    }
  }, [questionHistory]);

  if (examDetailsLoading !== undefined && examDetailsLoading === false && !questionsData.length && !demoQuestionMetadata?.questionMetadata?.errMsg && !qlinkQsIds?.errMsg) {
    return <div>Encountered error while fetching questions</div>
    // return null;
  }
  
  if (examDetailsLoading !== undefined && examDetailsLoading === false && !questionsData.length && !qlinkQsIds?.errMsg && (!questionMetadata?.errMsg || !demoQuestionMetadata?.questionMetadata?.errMsg)) {
    return <Box className={classes.noQuestionsAvailableMessage}>No questions found. Please retry.</Box>
  }

  if (examDetailsLoading !== undefined && examDetailsLoading === false &&!questionsData.length && qlinkQsIds?.errMsg) {
    return <Box className={classes.noQuestionsAvailableMessage}>This quiz link has expired or is no longer available.</Box>
  }

  return (
    <>
      {qlinkQsIds?.errMsg ? (
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
          color: '#d32f2f'
        }}>
          This quiz link has expired or is no longer available.
        </Box>
      ) : (
        <div className={`${classes[zoomClass]} ${!review ? 'quiz-page' : 'review-page'}`}>
          <Snackbar open={open} onClose={handleClose} autoHideDuration={4000}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Box className="success-alert">
              Thank you for your feedback...
            </Box>
          </Snackbar>
          <Snackbar open={errMsg} onClose={handleClose} autoHideDuration={4000}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Box className="sub-alert">
              {errMsg}
            </Box>
          </Snackbar>
          <Backdrop className={classes.backdrop} open={isLoading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Backdrop className={classes.backdrop} open={isImageLoading}>
            <CircularProgress color="inherit" />
          </Backdrop>

          {!demoQuestionMetadata?.errMsg &&
            <>
              {!guide &&
                <Box component="div" className={classes.examContainer}>
                  <ExamQuestionNumberList
                    questionData={questionsData}
                    onSelectQuestion={handleQuestionSelection}
                    examHistoryData={examHistoryData}
                    quizHistoryData={quizHistoryData}
                    questionMetaData={questionMetadataArr}
                    isReview={!!review}
                    currentQuestion={currentQuestionNum}
                  />
                  <Box component="div" className={`${classes.examContentContainer} exam-container-wrapper`}>
                    <ExamHeader
                      currentQuestion={currentQuestionNum}
                      questionData={questionsData}
                      questionMetaData={questionMetadataArr}
                      onSelectQuestion={handleQuestionSelection}
                      onTextZoom={handleTextZoom}
                      examHistoryData={examHistoryData}
                      onExamHistoryChange={onExamHistoryChange}
                      quizHistoryData={quizHistoryData}
                      isReview={!!review}
                      isTutor={!!tutor}
                      feedbackOpen={feedbackOpen}
                      onFeedbackClose={onFeedbackOpen}
                      goToHomePage={goToHomePage}
                      isUserAcquisition={isUserAcquisition}
                    />
                    {isTutorRole && tutor &&
                      <IconButton
                        onClick={() => onGuidePopOut()}
                        title="Pop Out"
                        className="pop-out-icon-outer"
                      >
                        <Launch />
                      </IconButton>
                    }
                    <ExamQuestionContainer
                      currentQuestionNum={currentQuestionNum}
                      dataLength={questionsData.length}
                      questionData={questionsData[currentQuestionNum - 1]}
                      onProceedToNextQuestion={handleProceedToNextQuestion}
                      isReview={!!review}
                      isTutor={!!tutor}
                      examHistoryData={examHistoryData}
                      onExamHistoryChange={onExamHistoryChange}
                      strikedHistoryData={strikedHistoryData}
                      onStrikeDataChange={onStrikeDataChange}
                      questionMetadata={questionMetadataArr}
                      quizHistoryData={quizHistoryData}
                      imageData={imageData}
                      onShowEndBlock={onShowEndBlock}
                      onFeedbackOpen={onFeedbackOpen}
                      isUserAcquisition={isUserAcquisition}
                      userDetailsFromTokenRes={userDetailsFromTokenRes}
                      handleFetchQuestionMetadata={fetchQuestionMetadata}
                      questionMetadataError={resolveQuestionMetadataError({
                        isUserAcquisition,
                        questionMetadataState,
                        demoQuestionMetadata,
                        qlinkQuestionMetadata: questionMetadataArr
                      })}
                      questionMetadataLoading={questionMetadataLoading || demoQuestionMetadata?.loading === true}
                      questionMetadataLoaded={questionMetadataLoaded || Array.isArray(demoQuestionMetadata?.questionMetadata) || !!demoQuestionMetadata?.questionMetadata?.errMsg || !!demoQuestionMetadata?.errMsg}
                      qlinkId={qId}
                      qlinkPlatform={qlinkPlatform}
                      quizId={examId}
                    />
                    <ExamFooter
                      isReview={!!review}
                      isTutor={!!tutor}
                      quizDetails={examDetails}
                      questionsDataLength={questionsData.length}
                      onEndBlock={onEndBlock}
                      showEndBlock={showEndBlock}
                      currentQuestionNum={currentQuestionNum}
                      isUserAcquisition={isUserAcquisition}
                      goToHomePage={goToHomePage}
                      userDetailsFromTokenRes={userDetailsFromTokenRes}
                    />
                  </Box>
                </Box>
              }
              {guide &&
                <Box className="quide-review-cont">
                  <ExamReviewDrawer
                    questionData={quesMetadata}
                    openDrawer={true}
                    isTutor={tutor}
                    isGuide={guide}
                    isReview={review}
                    isUserLoggedIn={isUserLoggedIn}
                    onFeedbackOpen={(evt, data) => onFeedbackOpen(true, data)}
                    handleFetchQuestionMetadata={fetchQuestionMetadata}
                  ></ExamReviewDrawer>
                </Box>
              }
            </>
          }
          {demoQuestionMetadata?.errMsg &&
            <Box className="invalid-link">Sorry. Please try again...</Box>
          }

        </div>
      )}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  examContainer: {
    display: "flex",
    flexDirection: "row",
    height: "100vh",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  examContentContainer: {
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  smallFont: {
    zoom: "100%",
  },
  mediumFont: {
    zoom: "110%",
  },
  largeFont: {
    zoom: "120%",
  },
  noQuestionsAvailableMessage: {
    fontSize: '20px',
    margin: '200px 50px',
    textAlign: 'center',
    height: '50px',
    color: '#d32f2f'
  }
}));
